import React, { createContext, useContext } from 'react';

const LayoutSizingContext = createContext({ controls: false, tables: false });

// Context crosses drawer/modal portals; it doesn't add a layout wrapper.
export function LayoutSizingScope({ children, tables }) {
  const parent = useContext(LayoutSizingContext);
  return <LayoutSizingContext.Provider value={{ controls: true, tables: tables ?? parent.tables }}>{children}</LayoutSizingContext.Provider>;
}
export const useLayoutSizing = () => useContext(LayoutSizingContext);
